import { useEffect, useState } from 'react';
import styles from './useFade.module.scss';

interface FadeProps {
  style: { [key: string]: string };
  onAnimationEnd: () => void;
}

const useFade = (initial: boolean) => {
  const [show, setShow] = useState(initial);
  const [isVisible, setVisible] = useState(show);

  // Update visibility when show changes
  useEffect(() => {
    if (show) {
      setVisible(true);
    }
  }, [show]);

  // When the animation finishes, set visibility to false
  const onAnimationEnd = () => {
    if (!show) setVisible(false);
  };

  const style = {
    animation: `${show ? styles.fadeIn : styles.fadeOut} 300ms ease ${
      show ? '' : 'forwards'
    }`,
  };

  // These props go on the fading DOM element
  const fadeProps: FadeProps = {
    style,
    onAnimationEnd,
  };

  return [isVisible, show, setShow, fadeProps] as const;
};

export default useFade;
